import { ActionBar, DeleteDialog, DistrictDialog } from './components';
import { useDialogState, useRowSelection } from './hooks';
import { ErpDataTableV2 } from '@/components/custom/erp';
import { getDataTableColumns } from './cols-definition';
import type { QuanHuyen } from '@/types/schemas';
import { useQuanHuyen } from '@/hooks/queries';

export default function DanhMucQuanHuyen({ initialRows = [] }: { initialRows?: QuanHuyen[] }) {
  const { districts, isLoading, addDistrict, updateDistrict, deleteDistrict } = useQuanHuyen(initialRows);
  const { selectedObj, selectedRowIndex, handleRowClick, clearSelection } = useRowSelection();
  const {
    showAddDialog,
    showEditDialog,
    showDeleteDialog,
    showWatchDialog,
    isCopyMode,

    openAddDialog,
    closeAddDialog,
    openEditDialog,
    closeEditDialog,
    openDeleteDialog,
    closeDeleteDialog,
    openWatchDialog,
    closeWatchDialog,

    handleAddButtonClick,
    handleEditButtonClick,
    handleDeleteButtonClick,
    handleCopyButtonClick
  } = useDialogState(clearSelection);

  // Xử lý dữ liệu để hiển thị tên tỉnh/thành
  const processedDistricts = districts.map(district => {
    // Thêm trường ten_tinh để hiển thị trong bảng
    if (district.tinh_thanh && district.tinh_thanh.ten_tinh) {
      return {
        ...district,
        ten_tinh: district.tinh_thanh.ten_tinh
      };
    }
    return district;
  });

  const tables = [
    {
      name: 'Danh mục quận/huyện',
      rows: processedDistricts,
      columns: getDataTableColumns(),
      icon: <div className='mr-2 size-[7px] rounded-full bg-red-500' />
    }
  ];

  return (
    <div className='flex h-full min-h-screen w-full min-w-0 max-w-full flex-col lg:overflow-hidden'>
      {(showAddDialog || showEditDialog) && (
        <DistrictDialog
          open={showAddDialog || showEditDialog}
          mode={showEditDialog ? 'edit' : 'add'}
          initialData={
            selectedObj && showEditDialog
              ? {
                  ma_quan: selectedObj.ma_quan,
                  ten_quan: selectedObj.ten_quan,
                  ten_quan2: selectedObj.ten_quan2,
                  ma_tinh: selectedObj.ma_tinh,
                  trang_thai: parseInt(selectedObj.status)
                }
              : selectedObj && showAddDialog && isCopyMode
                ? {
                    ma_quan: selectedObj.ma_quan,
                    ten_quan: selectedObj.ten_quan,
                    ten_quan2: selectedObj.ten_quan2,
                    ma_tinh: selectedObj.ma_tinh,
                    trang_thai: parseInt(selectedObj.status)
                  }
                : {
                    ma_quan: '',
                    ten_quan: '',
                    ten_quan2: '',
                    ma_tinh: '',
                    trang_thai: 1
                  }
          }
          onClose={showEditDialog ? closeEditDialog : closeAddDialog}
          selectedObj={showEditDialog ? selectedObj : null}
          addDistrict={addDistrict}
          updateDistrict={updateDistrict}
        />
      )}

      {showDeleteDialog && (
        <DeleteDialog
          open={showDeleteDialog}
          onClose={closeDeleteDialog}
          selectedObj={selectedObj}
          deleteDistrict={deleteDistrict}
          clearSelection={clearSelection}
        />
      )}

      {showWatchDialog && selectedObj && (
        <DistrictDialog
          open={showWatchDialog}
          mode='view'
          initialData={{
            ma_quan: selectedObj.ma_quan,
            ten_quan: selectedObj.ten_quan,
            ten_quan2: selectedObj.ten_quan2,
            ma_tinh: selectedObj.ma_tinh,
            trang_thai: parseInt(selectedObj.status)
          }}
          onClose={closeWatchDialog}
          selectedObj={selectedObj}
          addDistrict={addDistrict}
          updateDistrict={updateDistrict}
          onAddButtonClick={handleAddButtonClick}
          onEditButtonClick={handleEditButtonClick}
          onDeleteButtonClick={handleDeleteButtonClick}
          onCopyButtonClick={handleCopyButtonClick}
        />
      )}

      <div className='w-full'>
        <ActionBar
          onAddIconClick={openAddDialog}
          onEditIconClick={() => selectedObj && openEditDialog()}
          onDeleteIconClick={() => selectedObj && openDeleteDialog()}
          onCopyIconClick={() => selectedObj && handleCopyButtonClick()}
          onWatchIconClick={() => selectedObj && openWatchDialog()}
        />

        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          loading={isLoading}
        />
      </div>
    </div>
  );
}
